import { useState } from 'react'
import { getConsentStatus, resetConsent } from './consent'
import './PrivacySettings.css'

interface PrivacySettingsProps {
  onOpenPrivacyPolicy: () => void
}

export function PrivacySettings({ onOpenPrivacyPolicy }: PrivacySettingsProps) {
  const [isOpen, setIsOpen] = useState(false)
  const consent = getConsentStatus()

  const handleOpenSettings = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleChangePreferences = () => {
    // Reset consent which will show the banner again
    resetConsent()
    setIsOpen(false)
    // Reload the page to ensure analytics is properly reinitialized
    window.location.reload()
  }

  if (!isOpen) {
    return (
      <button
        onClick={handleOpenSettings}
        className="privacy-settings-trigger"
        aria-label="Privacy Settings"
      >
        Privacy Settings
      </button>
    )
  }

  return (
    <div className="privacy-settings-modal" role="dialog" aria-labelledby="privacy-settings-title">
      <div className="privacy-settings-overlay" onClick={handleClose} />
      <div className="privacy-settings-content">
        <div className="privacy-settings-header">
          <h3 id="privacy-settings-title">Privacy Settings</h3>
          <button
            onClick={handleClose}
            className="privacy-settings-close"
            aria-label="Close privacy settings"
          >
            ×
          </button>
        </div>

        <div className="privacy-settings-body">
          <div className="current-status">
            <p>
              <strong>Current Status:</strong>{' '}
              {consent.status === 'accepted' && (
                <span className="status-accepted">Analytics Enabled</span>
              )}
              {consent.status === 'rejected' && (
                <span className="status-rejected">Analytics Disabled</span>
              )}
              {consent.status === 'pending' && (
                <span className="status-pending">Not Set</span>
              )}
            </p>
            {consent.timestamp && (
              <p className="consent-date">
                Last updated: {new Date(consent.timestamp).toLocaleDateString()}
              </p>
            )}
          </div>

          <p>
            You can change your analytics preferences at any time. Your choice will
            be saved and the page will reload to apply the changes.
          </p>

          <div className="privacy-actions">
            <button
              onClick={handleChangePreferences}
              className="privacy-btn privacy-btn-change"
            >
              Change Preferences
            </button>
            <button
              onClick={onOpenPrivacyPolicy}
              className="privacy-btn privacy-btn-policy"
            >
              View Privacy Policy
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
